module.exports = __webpack_public_path__ + "pc/img/MO_top_720x474.1dcbaab4.png";